import React, { useEffect, useState } from "react";
import { Link, NavLink as RouterNavLink, useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Badge,
  Menu,
  MenuItem,
  Popover,
  ListItemButton,
  Divider,
  ListItemIcon,
} from "@mui/material";
import { styled, useTheme } from "@mui/system";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import useSignalingStore from "views/signalingStore";
import logoImage from "../../assets/img/logo_.svg";
import smallLogoImage from "../../assets/img/logo_small.svg";
import ModernProfileMenu from "components/profileMenu/profileMenu";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoMdNotificationsOutline } from "react-icons/io";
import { TbMessageCircle } from "react-icons/tb";
import messageIcon from "../../assets/img/messageIcon.svg";
import notificationIcon from "../../assets/img/notifIcon.svg";
import burgerIcon from "../../assets/img/burgerIcon.svg";
import {
  Person as PersonIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { COLORS } from "colors/color";
import LanguageSelector from "layouts/LanguageSelector";
import { useTranslation } from "react-i18next";

const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlsoket = process.env.REACT_APP_API_URL_SOKET;

const NavLink = styled(RouterNavLink)({
  color: COLORS.button_color,
  textDecoration: "none",
  padding: "8px 20px",
  marginRight: "16px",
  padding: "24px",
  fontWeight: 400,
  fontSize: "18px",
  position: "relative",
  transition: "all 0.3s ease",
  "&:hover": {
    color: "#2563eb",
  },
  "&.active": {
    textShadow: "0 0 5px #fff, 0 0 10px #fffa, 0 0 15px #fff",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-5px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "50%",
      height: "3px",
      backgroundColor: "#0085FF",
      borderRadius: "0px",
      boxShadow: "0 0 5px #fff, 0 0 10px #fffa, 0 0 15px #fff",
    },
  },
});

const StyledButton = styled(Button)({
  borderRadius: "30px",
  fontWeight: 500,
  transition: "all 0.3s ease",
  textTransform: "none",
});

const IconWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& .MuiIconButton-root": {
    color: "#1a1a1a",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
});

const StyledAppBar = styled(AppBar)(({ theme, isVisible }) => ({
  backgroundColor: "#0085FF1A",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  boxShadow: "none",
  borderRadius: "16px",
  width: "97%",
  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
  top: isVisible ? theme.spacing(2) : "-100px",
  transition: "top 0.3s ease",
  height: "80px",
  display: "flex",
  justifyContent: "center",
}));

const NavbarContent = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  maxWidth: "1200px",
});

const ButtonAppBar = ({
  isAuth,
  onLoginClick,
  onSignInClick,
  addPost,
  setChatComponent,
  hideWhileScrolling = 500,
  isShrinked,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t } = useTranslation();

  const {
    signalingServer,
    addMessage,
    addNotification,
    notifications,
    notificationMessages,
    incrementNotification,
    clearNotifications,
    fetchUnreadNotifications,
    markNotificationsAsRead,
    markNotificationAsRead,
    unreadNotifications,
    notificationCounts,
    getTotalNotifications,
    messagenotification,
    clearMessageNotifications,
    removeMessageNotification,
    updateNotificationCount,
    setInitialNotificationCounts,
    addMessageNotification,
  } = useSignalingStore();
  const [totalNotifications, setTotalNotifications] = useState(0);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    console.log("notifs:", notifications);
  }, [notifications]);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (isShrinked && currentScrollY > 800) {
        setIsVisible(false);
        return;
      }
      if (currentScrollY > hideWhileScrolling) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY, hideWhileScrolling, isShrinked]);

  useEffect(() => {
    fetchUnreadMessageCounts();
    // Note: WebSocket connections are now managed by WebSocketManager component
  }, []);

  useEffect(() => {
    setTotalNotifications(getTotalNotifications());
  }, [notificationCounts, getTotalNotifications]);

  const authRoutes = [
    {
      path: "/home",
      pro: false,
      icon: "home-icon-class",
      name: t("navBar.home"),
      layout: "",
    },
    {
      path: "/saved_posts",
      pro: false,
      icon: "blog-icon-class",
      name: t("navBar.saved_posts"),
      layout: "",
    },
    {
      path: "/post_applied",
      pro: false,
      icon: "about-icon-class",
      name: t("navBar.posts_applied"),
      layout: "",
    },
    // {
    //   path: "/joincaravan",
    //   pro: false,
    //   icon: "carnaval-icon-class", // replace with the correct icon class
    //   name: "Carnavals", // replace with the correct name
    //   layout: "",
    // },
    {
      path: "javascript:void(0)",
      pro: false,
      icon: "about-icon-class",
      name: t("navBar.contact_us"),
      layout: "",
      onClick: (e) => e.preventDefault(),
    },
  ];

  const noAuthRoutes = [
    {
      path: "/home",
      pro: false,
      icon: "home-icon-class",
      name: t("navBar.home"),
      layout: "",
    },
    {
      path: "/a-propos",
      pro: false,
      icon: "about-icon-class",
      name: t("navBar.about_us"),
      layout: "",
    },
    {
      path: "#",
      pro: false,
      icon: "about-icon-class",
      name: t("navBar.contact_us"),
      layout: "",
      onClick: (e) => e.preventDefault(),
    },
  ];

  const fetchUnreadMessageCounts = async () => {
    try {
      const response = await fetch(
        `${apiUrl}messaging/api/unread-message-counts/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch unread message counts");
      }
      const data = await response.json();
      setInitialNotificationCounts(data);
    } catch (error) {
      console.error("Error fetching unread message counts:", error);
    }
  };

  // Note: WebSocket connections are now managed by WebSocketManager component
  // Removed duplicate WebSocket creation logic to prevent infinite connection loops

  const [isAuth2, setIsAuth2] = useState(isAuth);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const navigate = useNavigate();
  const menuId = "primary-search-account-menu";

  const [userRole, setUserRole] = useState(getUserRoleFromAccessToken());

  function getUserRoleFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      //console.log("Access token : ", decodedToken);
      const userRole = decodedToken.role;
      return userRole;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    //console.log("payload : ", jsonPayload);

    return JSON.parse(jsonPayload);
  }

  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };

  const [profileAnchorEl, setProfileAnchorEl] = React.useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(profileAnchorEl);
  const isNotificationPopoverOpen = Boolean(notificationAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const chatButtonClicked = () => {
    navigate("/chat");
  };

  const handleProfileMenuOpen = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const navToProfile = () => {
    setProfileAnchorEl(null);
    handleMobileMenuClose();
    navigate("/profile");
  };

  const logOut = () => {
    setProfileAnchorEl(null);
    handleMobileMenuClose();
    localStorage.clear();
    if (window.location.pathname === "/landing") {
      window.location.reload();
    } else {
      navigate("/landing");
    }
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const [notifMessage, setNotifMessage] = useState(1);
  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMenu = isMobile ? (
    ""
  ) : (
    <Box
      sx={{
        width: "150px",
      }}
    >
      <ModernProfileMenu
        profileAnchorEl={profileAnchorEl}
        isMenuOpen={isMenuOpen}
        setProfileAnchorEl={setProfileAnchorEl}
        navToProfile={navToProfile}
        logOut={logOut}
      />
    </Box>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={totalNotifications} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>{t("navBar.messages")}</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge
            badgeContent={notifMessage}
            color="error"
            onClick={() => {
              setNotifMessage(0);
            }}
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>{t("navBar.notifications")}</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>{t("navBar.profile")}</p>
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    setIsAuth2(isAuth);
    console.log("auth", isAuth2);
  }, [isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetchUnreadNotifications();
    }
  }, [isAuth, fetchUnreadNotifications]);

  useEffect(() => {
    if (signalingServer) {
      signalingServer.onmessage = (event) => {
        const message = JSON.parse(event.data);
        console.log("Received message:", message);

        addMessage(message);

        if (message.type === "notif") {
          addNotification({
            content: message.notif,
            timestamp: new Date().toISOString(),
            link: message.link,
          });
          console.log("Received notification: final", message);
        }
      };
    }
  }, [signalingServer, addMessage, addNotification]);

  const handleNotificationClick = (event, link) => {
    setNotificationAnchorEl(event.currentTarget);

    handleNotificationClose();
    if (link) {
      navigate(link);
    }
  };

  const userId = getUserIdFromAccessToken();

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      const userId = decodedToken.user_id;
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  const handlePopoverClose = () => {
    setNotificationAnchorEl(null);
  };

  const isPopoverOpen = Boolean(notificationAnchorEl);
  const popoverId = isPopoverOpen ? "notification-popover" : undefined;

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
    markNotificationsAsRead();
  };

  const handleNotificationButtonClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
    fetchUnreadNotifications();
  };

  const handleNotificationItemClick = (event, notification) => {
    markNotificationAsRead(notification.id);
    handleNotificationClose();
    if (notification.link) {
      navigate(notification.link);
    }
  };

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const drawerContent = (
    <Box
      sx={{
        background: "rgba(0, 133, 255, 0.1)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        height: "100%",
        color: "white",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          zIndex: -1,
        },
      }}
    >
      <List component="nav" sx={{ pt: 2, px: 2 }}>
        {(isAuth ? authRoutes : noAuthRoutes).map((route, index) => (
          <ListItem
            key={index}
            component={RouterNavLink}
            to={route.path}
            sx={{
              px: 1.5,
              py: 1.5,
              borderRadius: "8px",
              fontSize: "15px",
              transition: "all 0.3s ease",
              position: "relative",
              overflow: "hidden",
              mb: 1,
              color: "#fff",
              "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                width: "2px",
                height: "100%",
                backgroundColor: "#fff",
                transform: "scaleY(0)",
                transition: "transform 0.3s ease",
              },
              "&:hover": {
                backgroundColor: "rgba(0, 133, 255, 0.1)",
                "&::before": {
                  transform: "scaleY(1)",
                },
                "& .MuiListItemIcon-root": {
                  transform: "translateX(2px)",
                  color: "#0085FF",
                },
                "& .MuiListItemText-primary": {
                  color: "#fff",
                },
              },
              "&.active": {
                backgroundColor: "rgba(0, 133, 255, 0.1)",
                "&::before": {
                  transform: "scaleY(2)",
                  backgroundColor: "#0085FF",
                },
                "& .MuiListItemIcon-root": {
                  color: "#fff",
                },
                "& .MuiListItemText-primary": {
                  color: "#fff",
                },
              },
            }}
          >
            <ListItemText
              primary={route.name}
              primaryTypographyProps={{
                fontSize: "15px",
                fontWeight: 500,
                fontFamily: "Poppins",
              }}
            />
          </ListItem>
        ))}

        {isAuth && (
          <>
            <Divider
              sx={{
                my: 2,
                borderColor: "rgba(255, 255, 255, 0.1)",
                margin: "8px 4px",
              }}
            />
            <Divider
              sx={{
                my: 2,
                borderColor: "#fff",
              }}
            />
            <Box sx={{ px: 1.5, mb: 2 }}>
              <Typography
                variant="overline"
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: COLORS.white,
                  letterSpacing: "0.5px",
                  textTransform: "none",
                  fontFamily: "Poppins",
                }}
              >
                {t("navBar.account_settings")}
              </Typography>
            </Box>

            <ListItem
              component={RouterNavLink}
              to="/profile"
              onClick={navToProfile}
              sx={{
                px: 1.5,
                py: 1.5,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
                mb: 1,
                color: "#fff",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  width: "2px",
                  height: "100%",
                  backgroundColor: "#0085FF",
                  transform: "scaleY(0)",
                  transition: "transform 0.3s ease",
                },
                "&:hover": {
                  backgroundColor: "rgba(0, 133, 255, 0.1)",
                  "&::before": {
                    transform: "scaleY(1)",
                  },
                  "& .MuiListItemIcon-root": {
                    transform: "translateX(2px)",
                    color: "#0085FF",
                  },
                  "& .MuiListItemText-primary": {
                    color: "#fff",
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                {localStorage.getItem("userImage") ? (
                  <img
                    src={localStorage.getItem("userImage")}
                    alt="Profile"
                    referrerPolicy="no-referrer"
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "1px solid #fff"
                    }}
                  />
                ) : (
                  <PersonIcon sx={{ fontSize: 20, color: COLORS.white }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={t("navBar.profile")}
                primaryTypographyProps={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                }}
              />
            </ListItem>

            <ListItem
              onClick={logOut}
              sx={{
                px: 1.5,
                py: 1.5,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  width: "2px",
                  height: "100%",
                  backgroundColor: "error.main",
                  transform: "scaleY(0)",
                  transition: "transform 0.3s ease",
                },
                "&:hover": {
                  backgroundColor: "rgba(0, 133, 255, 0.1)",
                  "&::before": {
                    transform: "scaleY(1)",
                  },
                  "& .MuiListItemIcon-root": {
                    transform: "translateX(2px)",
                    color: "error.main",
                  },
                  "& .MuiListItemText-primary": {
                    color: "error.main",
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <LogoutIcon sx={{ fontSize: 20, color: COLORS.white }} />
              </ListItemIcon>
              <ListItemText
                primary={t("navBar.logout")}
                primaryTypographyProps={{
                  fontSize: "15px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                }}
              />
            </ListItem>
          </>
        )}
      </List>
    </Box>
  );

  return (
    <StyledAppBar isVisible={isVisible} elevation={0}>
      <Toolbar>
        <NavbarContent>
          <Box>
            <img
              src={smallLogoImage}
              alt="Logo"
              style={{
                width: isSmallScreen ? "15px" : "20px",
                marginRight: isSmallScreen ? "25px" : 160,
              }}
              onClick={() => {
                navigate("/home");
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!isMobile &&
                (isAuth ? authRoutes : noAuthRoutes).map((route, index) => (
                  <NavLink
                    sx={{ fontFamily: "Poppins" }}
                    key={index}
                    to={route.path}
                  >
                    {route.name}
                  </NavLink>
                ))}
            </Box>
          </Box>

          {isAuth ? (
            <IconWrapper>
              {isMobile && (
                <IconButton size="large" onClick={handleDrawerToggle}>
                  <RxHamburgerMenu
                    style={{ color: "white", fontSize: "24px" }}
                  />
                </IconButton>
              )}

              {!isMobile && (
                <>
                  <IconButton size="large" onClick={chatButtonClicked}>
                    <Badge
                      badgeContent={totalNotifications}
                      color="transparent"
                    >
                      <img
                        src={messageIcon}
                        alt="Message Icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </Badge>
                  </IconButton>

                  <IconButton
                    size="large"
                    onClick={handleNotificationButtonClick}
                  >
                    <Badge
                      badgeContent={
                        Array.isArray(unreadNotifications)
                          ? unreadNotifications.length
                          : 0
                      }
                      color="primary"
                    >
                      <img
                        src={notificationIcon}
                        alt="notification Icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </Badge>
                  </IconButton>
                  <IconButton onClick={handleProfileMenuOpen} sx={{ p: 0 }}>
                    {localStorage.getItem("userImage") ? (
                      <img
                        src={localStorage.getItem("userImage")}
                        alt="Profile"
                        referrerPolicy="no-referrer"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #fff"
                        }}
                      />
                    ) : (
                      <img
                        src={burgerIcon}
                        alt="Menu Icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                    )}
                  </IconButton>
                </>
              )}

              {userRole === "r" && (
                <StyledButton
                  variant="contained"
                  onClick={() =>
                    navigate("/talent/dashboard", {
                      state: { recruiter: true },
                    })
                  }
                  sx={{
                    backgroundColor: "#2563eb",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#1d4ed8",
                    },
                  }}
                >
                  {t("navBar.recruiter_space")}
                </StyledButton>
              )}
            </IconWrapper>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              <StyledButton
                variant="outlined"
                onClick={() =>
                  navigate("/login", { state: { authMode: "signup" } })
                }
                sx={{
                  borderColor: "#fff",
                  color: "#2563eb",
                  width: isMobile ? 80 : 104,
                  height: isMobile ? 35 : 40,
                  backgroundColor: "#FFFFFF4D",
                  "&:hover": {
                    borderColor: "#1d4ed8",
                    backgroundColor: "rgba(37, 99, 235, 0.04)",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: isMobile ? 10 : "11px",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                  }}
                >
                  {t("navBar.sign_up")}
                </Typography>
              </StyledButton>
              <StyledButton
                variant="contained"
                onClick={() => navigate("/login")}
                sx={{
                  width: isMobile ? 80 : 104,
                  height: isMobile ? 35 : 40,
                  border: "1px solid #fff",
                  backgroundColor: "#2563eb",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#1d4ed8",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: isMobile ? 10 : "11px",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                  }}
                >
                  {t("navBar.login")}
                </Typography>
              </StyledButton>
            </Box>
          )}
        </NavbarContent>
      </Toolbar>

      <Drawer
        PaperProps={{
          sx: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          },
        }}
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
      >
        {drawerContent}
      </Drawer>

      {renderMobileMenu}
      {renderMenu}

      <Popover
        PaperProps={{
          elevation: 0,
          sx: {
            mt: 3,
            width: "250px",
            background: "#0085FF1A",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            color: "white",
            overflow: "hidden",
            borderRadius: "12px",
            transition: "all 0.3s ease",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              zIndex: -1,
            },
            "& .MuiMenuItem-root": {
              px: 1.5,
              py: 1.5,
              fontSize: "15px",
              transition: "all 0.3s ease",
              position: "relative",
              overflow: "hidden",
              "&:before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                width: "2px",
                height: "100%",
                backgroundColor: "#0085FF",
                transform: "scaleY(0)",
                transition: "transform 0.3s ease",
              },
              "&:hover": {
                backgroundColor: "rgba(0, 133, 255, 0.1)",
                "&:before": {
                  transform: "scaleY(1)",
                },
                "& .MuiSvgIcon-root": {
                  transform: "translateX(2px)",
                  color: "#0085FF",
                  transition: "all 0.3s ease",
                },
              },
            },
            "& .MuiDivider-root": {
              borderColor: "rgba(255, 255, 255, 0.1)",
              margin: "1px 4px",
            },
          },
        }}
        id={popoverId}
        open={isPopoverOpen}
        anchorEl={notificationAnchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List>
          {unreadNotifications.length > 0 ? (
            unreadNotifications.map((notification) => (
              <ListItemButton
                key={notification.id}
                onClick={() => handleNotificationItemClick(null, notification)}
              >
                <ListItemText primary={notification.content} />
              </ListItemButton>
            ))
          ) : (
            <ListItemText primary={t("notifications.no_new_notifications")} />
          )}
        </List>
      </Popover>
    </StyledAppBar>
  );
};

export default ButtonAppBar;
